import { LoadingOutlined } from '@ant-design/icons'
import { Col, Row, Spin } from 'antd'
import React from 'react'

const Spinner = ({ fontSize = '4rem' }: { fontSize?: string }) => {
  return (
    <Row justify="center" align="middle">
      <Col>
        <Spin indicator={<LoadingOutlined style={{ fontSize }} spin />} />
      </Col>
    </Row>
  )
}

export default Spinner
